import Vue from 'vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Dropdown from '@/components/dropdown/Dropdown.vue'
import Tree from '@/components/tree/Tree.vue'
import Sidebar from '@/components/sidebar/Sidebar.vue'
import Loader from '@/components/loader/Loader.vue'
import Cam from '@/components/cam/Cam.vue'
import Search from '@/components/search/Search.vue'
import ViewTabs from '@/modules/viewTabs/ViewTabs.vue'
import Alarms from '@/modules/alarms/Alarms.vue'
import UserInfo from '@/modules/userInfo/UserInfo.vue'
import { EventBus } from '@/services//EventBus.js'


function getVisualRectPersent() {
    return {
        left: 0,
        right: 100,
        top: 0,
        bottom: 100
    }
}

export default {
    name: 'Dashboard',
    data () {
        return {
            videoStreams: [
                { name: 'Base', value: 1 },
                { name: 'Low resolution', value: 2 },
                { name: 'High resolution', value: 3 },
            ],
            modes: [
                { name: 'Live', value: 0, alias: 'live' },
                { name: 'Playback', value: 1, alias: 'playback' },
            ],
            sidebars: {
                cams: {
                    open: true,
                    show: true,
                    search: '',
                    scroll: null,
                    modes: {
                        active: 'list',
                        list: [
                            { name: 'List', value: 'list' },
                            { name: 'Preview', value: 'preview' }
                        ]
                    }
                },
                maps: {
                    open: true,
                    search: '',
                    modes: {
                        active: 'map',
                        list: [
                            { name: 'Map', value: 'map' },
                            { name: 'Video', value: 'views' }
                        ]
                    }
                },
            },
            loading: {
                alarms: false
            },
            modals: {
                agreement: true
            },
            visualRectPersent: getVisualRectPersent()
        }
    },
    components: {
        ViewTabs,
        Dropdown,
        Tree,
        Sidebar,
        Loader,
        Cam,
        VuePerfectScrollbar,
        UserInfo,
        Search
    },
    created: function() {
        this.$store.dispatch('getViews')
        this.$store.dispatch('getMaps')

        EventBus.$on('resize:end', () => {
            this.updateScroll(this.$refs.camsScroll)
            this.updateScroll(this.$refs.mapsScroll)
            this.updateScroll(this.$refs.mapsAlarmScroll)
        })
        EventBus.$on('changeMapPosition', this.onChangeMapPosition)
    },
    mounted() {
        this.setCamsMode('list')
    },
    computed: {
        ...mapGetters({
            maps: 'getMaps',
            alarmMaps: 'getAlarmMaps',
            allCams: 'getCams',
            views: 'getViews',
            alarms: 'getAlarms',
            latestAlarms: 'getLatestAlarms',
            user: 'getUser',
            activeView: 'getActiveView',
            grids: 'getGrids',
            stream: 'getStream',
            activeGrid: 'getActiveGrid',
            activeMap: 'getActiveMap',
            getMapById: 'getMapById',
        }),
        cams() {
            let cams = this.allCams.filter(item => {
                let name = item.name.toLowerCase()
                let search = this.sidebars.cams.search.toLowerCase()

                return name.indexOf(search) > -1
            })

            return cams || []
        },
        camGroups() {
            const groups = []
            const pathDelimeter = /[#:]+/
            this.cams.forEach(camObj => {
                const groupPath = camObj.name.split(pathDelimeter).map(path => path.trim())
                if (groupPath.length > 1) {
                    let existGroup = null
                    for (let i = 0; i < groupPath.length; i++) {
                        const path = groupPath[i]
                        if (i === 0) {
                            existGroup = groups.find(g => Array.isArray(g) && g[0].value === path)
                            if (!existGroup) {
                                existGroup = [
                                    {
                                        value: path,
                                        name: path,
                                        children: []
                                    }
                                ]
                                groups.push(existGroup)
                            }
                        } else {
                            const pathItem = groupPath.slice(0, i + 1).join(pathDelimeter)
                            const pathParent = groupPath.slice(0, i).join(pathDelimeter)
                            if (!existGroup[0].children.find(item => {
                                return item.pathParent === pathParent && item.value === pathItem
                            })) {
                                if (i !== groupPath.length - 1) {
                                    
                                    existGroup[0].children.push({
                                        name: path,
                                        value: pathItem,
                                        parent: i == 1 ? 0 : pathParent,
                                        pathParent
                                    })
                                } else {
                                    existGroup[0].children.push({
                                        ...camObj,
                                        name: path,
                                        value: pathItem,
                                        parent:  i == 1 ? 0 : pathParent,
                                        pathParent
                                    })
                                }
                            }
                        }
                    }
                } else {
                    groups.push(camObj)
                }
            })
            return groups
        },
        mapData() {
            const mapData = this.maps.map(group => {
                if (group) {
                    let map = group.map.map(item => {
                        return {
                            value: item.id,
                            name: item.name,
                            parent: item.parent,
                        }
                    })
    
                    return {
                        value: group.id,
                        name: group.name,
                        children: map
                    }
                }
            })
            return mapData
        },
        alarmMapData() {

            return this.alarmMaps.map(group => {
                if (group) {
                    let map = group.map.map(item => {
                        return {
                            value: item.id,
                            name: item.name,
                            parent: item.parent,
                        }
                    })
    
                    return {
                        value: group.id,
                        name: group.name,
                        children: map
                    }
                }
            })
        },
        disableGrid() {
            return this.$route.name === 'alarms'
                || (this.$route.name === 'map' && this.$store.state.mapMode === 'map')
                || (this.$route.name === 'map' && this.activeMap && ! this.activeMap.cams.length)
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                switch (route.name) {
                    case 'alarms':
                        this.sidebars.cams.show = false
                        this.sidebars.maps.open = false
                        break

                    case 'views':
                        this.sidebars.cams.show = true;

                        if (route.params.mapId && route.params.mapGroupId)
                            this.sidebars.maps.modes.active = 'views'

                        this.$nextTick(() => EventBus.$emit('views:select'))
                        break

                    case 'map':
                        this.sidebars.cams.show = true;
                        break
                }
            }
        },
        activeMap(map) {
            if (map && this.sidebars.maps.modes.active === 'views') {
                const camsFilter = map.cams.filter(cam => {
                    return cam.x >= this.visualRectPersent.left && cam.x <= this.visualRectPersent.right &&
                           cam.y >= this.visualRectPersent.top && cam.y <= this.visualRectPersent.bottom
                })
                let cams = this.$route.params.camId ? [this.$route.params.camId] : camsFilter.map(cam => cam.id)
                this.$store.commit('resetTempView')

                this.$store.commit('addCamsIntoView', {
                    camIds: cams,
                    viewId: 'main',
                })
            }
        }
    },
    methods: {
        setMap(map) {
            let params = { mapGroupId: map.root, mapId: map.value }
            let mode = this.sidebars.maps.modes.active

            if (mode === 'views')
                params.viewId = 'main'

            this.$router.push({ name: mode, params: params })
        },
        setMode(mode) {
            this.$store.commit('setMode', mode)

            this.$nextTick(() => {
                EventBus.$emit('mode:change')
            })
        },
        setCamsMode(mode) {
            this.sidebars.cams.modes.active = mode
            this.updateScroll(this.$refs.camsScroll)
        },
        setGrid(grid) {
            this.$store.dispatch('setGrid', grid.value)
            this.$nextTick(() => {
                EventBus.$emit('views:select')
            })
        },
        changeMapMode(mode) {
            if (mode === 'map') {
                this.visualRectPersent = getVisualRectPersent()
            }
            if (this.activeMap) {
                let params = { mapGroupId: this.activeMap.group.id, mapId: this.activeMap.id }

                if (mode === 'views')
                    params.viewId = 'main'
                this.$router.push({ name: mode, params: params })
            }

            this.sidebars.maps.modes.active = mode
        },
        onChangeMapPosition(visualRectPersent) {
            this.visualRectPersent = {...visualRectPersent}
        },
        getAllAlarms() {
            this.sidebars.cams.show = false
            this.$router.push({ name: 'alarms' })
        },
        updateScroll(ref) {
            if (ref) {
                this.$nextTick(() => {
                    ref.update()
                })
            }
        },
        openAlarms() {
            this.loading.alarms = true
            const params = {
                start_time: moment().startOf('day').format(),
                stop_time: moment().format(),
                max_count: 6,
            }
            if (this.$route.name === 'alarms') {
                params.max_count = 30
            }
            this.$store.dispatch('getAlarms', {
                cams:  this.cams,
                params
            }).then(() => {
                this.loading.alarms = false
            })
        },
        getAlarmComment(alarm) {
            return Alarms.methods.getComment(alarm)
        },
        onSelectStream(stream) {
            this.$store.commit('changeStream', stream.value)
        },
        goToAlarm(alarm) {
            this.$store.commit('setMode', 1)
            this.$router.push({
                name: 'alarms',
                params: { alarmId: alarm.id }
            })
        },
        isCamSelected(cam) {
            if (this.activeView)
                return this.activeView.cams.some(c => c.id == cam.id)

            if (this.activeMap)
                return this.activeMap.cams.some(c => c.id == cam.id)

            return false
        },
        onCamDrag(data, event) {
            EventBus.$emit('cam:dragstart')

            event.dataTransfer.setData('text', JSON.stringify({
                camera_id: data.camera_id,
                connection_id: ''
            }))
        },
    },
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/dashboard.js